<script setup>
defineProps({
    value: String,
})
</script>

<template>
    <h2
        class="font-roboto mt-10 text-4xl leading-[3.4rem] font-bold tracking-wide text-pretty text-zinc-800 uppercase sm:text-3xl dark:text-zinc-200"
    >
        <template v-if="value">{{ value }}</template>
        <template v-else><slot /></template>
    </h2>
</template>
